import rawContentfulPromoData from "@/data/contentfulPromoData.json";
import { PromoData } from "@/types/promoData";

// Cast the imported JSON data to the typed array
const contentfulPromoData = rawContentfulPromoData as unknown as PromoData[];

/**
 * Get promo data by name
 * @param name - The name of the promo to retrieve
 * @returns The promo data object with the matching name, or undefined if not found
 */
export const getPromoByName = (name: string): PromoData | undefined => {
  return contentfulPromoData.find((promo) => promo.name === name);
};
